export enum PAGE_TYPE {
  DISCOVER = "discover",
  BRAND = "brand",
  PRODUCT = "product",
  CATEGORY = "category",
  HOMEPAGE = "homepage",
  CART = "cart",
  DIRECT = "direct",
}
